import { serviceRequest } from 'utils/http';
import { ReferralService } from 'common/api';
import { REFERRAL_SOURCE_EXTERNAL } from 'services/referrals/referral-source.constants';

type UpdateReferralNote = {
  id?: string;
  note: string | undefined;
  isExternalReferral?: boolean;
};

export function updateReferralNoteAPI({
  id,
  note,
  isExternalReferral = false,
}: UpdateReferralNote) {
  return serviceRequest(() =>
    ReferralService.referralControllerChangeNoteAsCurrentUser(
      id || '',
      { note },
      isExternalReferral ? REFERRAL_SOURCE_EXTERNAL : undefined
    )
  );
}
